export const _CHANGE_PAGE = '_CHANGE_PAGE'
export const _CHANGE_LIMIT = '_CHANGE_LIMIT'
export const _SET_PAGINATION = '_SET_PAGINATION'
